import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import API from 'api';
// import { setSelectedLocation } from "./travelLocations.slice";

// Add trek
export const addTrek = createAsyncThunk(
    'trek/addTrek',
    async (trekData, { rejectWithValue }) => {
        try {
            const response = await API.post("/trek/createLocation", trekData);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || "Failed to add Trek data");
        }
    }
)
// updateTrek 
export const updateTrek = createAsyncThunk(
    'trek/updateTrek',
    async ({ id, formData }, { rejectWithValue }) => {
        console.log("formData in slice:", formData);

        try {
            const response = await API.put(`/trek/updateData/${id}`, formData);
            return response.data;

        } catch (error) {
            return rejectWithValue(error.response?.data?.message || "update the Trek Data");
        }
    }
)
// featchTrek
export const featchTrek = createAsyncThunk(
    'trek/featchTrek',
    async (_, { rejectWithValue }) => {
        try {
            const response = await API.get('/trek/getTrek');
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || "Failed to featch trek data");
        }
    }
)

// delete trek 
export const deleteTrek = createAsyncThunk(
    'trek/deleteTrek',
    async (id, { rejectWithValue }) => {
        try {
            await API.delete(`/trek/deleteLocation/${id}`);
            return id;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || "Failed to delete trekData")
        }
    }
)

export const softDeleteTrek = createAsyncThunk(
    'trek/softDeleteTrek',
    async (id, { rejectWithValue }) => {
      try {
        await API.put(`/trek/softDelete/${id}`);
        return { id };  // ✅ Return ID to remove from state instantly
      } catch (error) {
        return rejectWithValue(error.response?.data?.message || "Failed to move trek to trash");
      }
    }
  );

export const fetchTrashedTrek = createAsyncThunk(
    'trek/fetchTrashedTrek',
    async (_, { rejectWithValue }) => {
        try {
            const response = await API.get('/trek/trashed');
            return response.data;
        } catch (error) {
            if (error.response?.status === 401) {
                try {
                    const fallbackResponse = await API.get('/trek/getTrek?isDeleted=true');
                    return fallbackResponse.data;
                } catch (fallbackError) {
                    return rejectWithValue(
                        fallbackError.response?.data?.message || "Failed to fetch trashed trek data"
                    );
                }
            }
            return rejectWithValue(error.response?.data?.message || "Failed to fetch trashed trek data");
        }
    }
);

export const restoreTrek = createAsyncThunk(
    'trek/restoreTrek',
    async (id, { rejectWithValue }) => {
        try {
            const response = await API.put(`/trek/restore/${id}`);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || "Failed to restore trek data");
        }
    }
);

export const permanentDeleteTrek = createAsyncThunk(
    'trek/permanentDeleteTrek',
    async (id, { rejectWithValue }) => {
        try {
            await API.delete(`/trek/permanentDelete/${id}`);
            return id;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || "Failed to permanently delete trek");
        }
    }
);



const trekSlice = createSlice({
    name: "trek",
    initialState: {
        trek: [],
        status: 'idle',
        error: null,
        selectedLocation: [],
        trashedTrek: [],
    },
    reducers: {
        setSelectedLocation: (state, action) => {
            state.selectedLocation = action.payload
        }
    },
    extraReducers: (builder) => {
        builder
            // Add Trek
            .addCase(addTrek.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(addTrek.fulfilled, (state, action) => {
                state.status = 'succeeded';
                const payload = action.payload?.location || action.payload;
                if (payload) state.trek.push(payload);
            })
            .addCase(addTrek.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            })

            // Delete Trek
            .addCase(deleteTrek.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(deleteTrek.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.trek = state.trek.filter((trek) => trek.id !== action.payload);
            })
            .addCase(deleteTrek.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            })

            // Update Trek
            .addCase(updateTrek.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(updateTrek.fulfilled, (state, action) => {
                state.status = 'succeeded';

                const updatedTrek = action.payload; // ✅ Get full updated trek data
                const index = state.trek.findIndex((trek) => trek._id === updatedTrek._id);

                if (index !== -1) {
                    state.trek[index] = updatedTrek; // ✅ Replace with updated data
                }
            })
            .addCase(updateTrek.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            })

        // Fetch Trek
        .addCase(featchTrek.pending, (state) => {
            state.status = 'loading';
        })
        .addCase(featchTrek.fulfilled, (state, action) => {
            state.status = 'succeeded';
            state.trek = action.payload;
        })
        .addCase(featchTrek.rejected, (state, action) => {
            state.status = 'failed';
            state.error = action.payload;
        })

        
        .addCase(softDeleteTrek.fulfilled, (state, action) => {
            // ✅ Remove the deleted location from state instantly
            state.trek = state.trek.filter((trek) => trek._id !== action.payload.id);
        })
        
        
        // 🗑️ Fetch Trashed
        .addCase(fetchTrashedTrek.fulfilled, (state, action) => {
            state.trashedTrek = action.payload;
        })

        // 🔄 Restore
        .addCase(restoreTrek.fulfilled, (state, action) => {
            state.trek.push(action.payload.restoredLocation);
            state.trashedTrek = state.trashedTrek.filter(t => t._id !== action.payload.restoredLocation._id);
        })

        // ❌ Permanent Delete
        .addCase(permanentDeleteTrek.fulfilled, (state, action) => {
            state.trashedTrek = state.trashedTrek.filter((t) => t._id !== action.payload);
        });
}
});

export default trekSlice.reducer;
